import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { Period } from '@/lib/timePeriod';
import type { FraudByMakeResponse } from '@/types/fraudHub';

/**
 * Fetches fraud alert_count broken down by vehicle make from the NEW
 * `/fraud-hub/by-make` endpoint (backed by `analytics.fraud_alert_daily_by_dim`).
 * Period-aware; `limit` caps the number of makes returned (ordered by
 * alert_count desc). Doubles as the option source for the make Autocomplete in
 * the FraudFilterBar.
 */
export function useFraudHubByMake(
  period: Period,
  limit = 15,
): UseQueryResult<FraudByMakeResponse, Error> {
  return useQuery<FraudByMakeResponse, Error>({
    queryKey: ['fraud-hub', 'by-make', period, limit],
    queryFn: async () => {
      const { data } = await api.get<FraudByMakeResponse>('/fraud-hub/by-make', {
        params: { period, limit },
      });
      return data;
    },
    staleTime: 30_000,
  });
}
